"use client"

import type React from "react"

import { clsx } from "clsx"

import { LoadingSpinner } from "@/components/flow/LoadingSpinner"

type ButtonVariant = "primary" | "secondary" | "inverted"

interface SubmitButtonProps {
  text: React.ReactNode
  isLoading: boolean
  disabled: boolean
  onClick?: () => void
  variant?: ButtonVariant
}

const baseClasses = "w-full rounded-full py-4 font-medium font-manrope text-[14px] transition-colors duration-300"

const getVariantClasses = (variant: ButtonVariant, disabled: boolean, isLoading: boolean) => {
  if (isLoading) {
    return "border-none bg-nelo-blue-pressed text-fg-inverted"
  }
  if (disabled) {
    return "border-none bg-nelo-disabled-gray text-fg"
  }

  switch (variant) {
    case "inverted":
      return "border-2 border-nelo-blue bg-surface text-fg-brand hover:bg-brand-muted"
    case "secondary":
      return "border-none bg-surface-success-deep text-fg-inverted hover:bg-surface-success-deep/85"
    case "primary":
    default:
      return "border-none bg-nelo-blue text-fg-inverted hover:bg-nelo-blue-pressed active:bg-nelo-blue-pressed"
  }
}

export const SubmitButton: React.FC<SubmitButtonProps> = ({ text, isLoading, disabled, onClick, variant = "primary" }) => {
  return (
    <button type="submit" form="native-form" disabled={disabled || isLoading} onClick={onClick} className={clsx(baseClasses, getVariantClasses(variant, disabled, isLoading))}>
      {isLoading ? (
        <span className="inline-flex w-full items-center justify-center">
          <LoadingSpinner />
        </span>
      ) : (
        <>{text}</>
      )}
    </button>
  )
}
